<!-- 代券活动界面 -->
<style>
    .ticket-container{
        mask-composite: intersect;/* 设置遮罩组合模式 */
        mask-image:
            radial-gradient(circle at left 17.5rem, transparent .8rem, #fff .85rem),
            radial-gradient(circle at right 17.5rem, transparent .8rem, #fff .85rem);
        background: radial-gradient(#00064f,#000010);
        width: 15rem;
        height: 22rem;
    }
    .font-family-serif{
        font-family: serif;
    }
    .mt-1_25rem{
        margin-top: -1.25rem;
    }
    .ticket-container .bi-x-lg::before{
        font-weight: bold !important;
    }
    .triangle-top-end{
        border-width: 1.5rem; 
        border-style:solid;
        border-color:#d3d360;
        border-left-color:transparent;
        border-bottom-color:transparent;
    }
    .triangle-top-end:hover{
        border-top-color:#ffff00;
        border-right-color:#ffff00;
    }
    .btn-khaki{
        background: linear-gradient(0deg,#aeae55,#fdfd87);
    }
    .btn-khaki:hover{
        background: linear-gradient(0deg,#b8b82c,#ffff4e);
    }
</style>
<template>
    <!-- 主面板 -->
    <div v-load v-if="isShowPanel" class="d-flex flex-column position-fixed top-50 start-50 translate-middle rounded-3 text-light p-2 ticket-container index-13">
        <!-- 水印 -->
        <div class="d-flex flex-wrap position-absolute top-0 end-0 start-0 bottom-0 opacity-75 fs-_8rem text-secondary text-opacity-50 index-0">
            <span class="px-2 rotate-30" v-for="i in 40" :key="i">{{prize}}代券</span>
        </div>
        <!-- 面额 -->
        <div class="d-flex justify-content-center align-items-end mb-2">
            <span class="lh-1 fs-_8rem text-info">代券</span>
            <div class="position-relative">
                <i class="position-absolute fs-1 fw-bold lh-1 font-family-serif px-2" style="color:#ffff88;mask-image: linear-gradient(90deg, #ffff88 20%, transparent 50%,#ffff88 100%);">{{prize}}</i>
                <i class="d-flex fs-1 fw-bold font-family-serif lh-1 px-2" style="color:#999947">{{prize}}</i>
            </div>
            <!-- 银币 -->
            <div v-if="prizeType==TASK_PRIZE_TYPE.silverTicket" class="rounded-circle bg-warning w-1rem h-1rem d-flex justify-content-center align-items-center text-primary" style="background:linear-gradient(90deg, #56565f, #E6E6FA);box-shadow: -.1rem 0 0 #fff inset, 0 0 0 .1rem #bbbbc9 inset, .15rem 0 0 #8c8c99, .2rem 0 0 #2a2a2a;transform: rotateY(15deg) rotateZ(15deg);">
                <i class="d-flex bi bi-suit-heart-fill" style="color:#db0000;transform: scale(.55);text-shadow: #830000 .1rem 0 .1rem"></i>
            </div>
        </div>
        <!-- 任务 -->
        <div class="flex-grow-1 border border-secondary rounded-3 mx-2 mb-2 small overflow-hidden d-flex flex-column position-relative">
            <span class="bg-warning bg-gradient px-1 d-block fw-bold text-dark small">今日任务</span>
            <div class="flex-grow-1 p-1 fs-_6rem lh-sm">{{taskText}}<span class="text-warning">（<span :class="[taskProgress[0]>=taskProgress[1]?'text-light':'text-secondary']">{{ taskProgress[0] }}</span>/{{taskProgress[1]}}）</span></div>
        </div>
        <!-- 说明 -->
        <div class="d-flex flex-column mx-2 pb-3 mb-3 border-2 border-top-0 border-start-0 border-end-0 border-dashed border-secondary">
            <span class="small fw-bold">活动说明：</span>
            <div class="d-flex flex-column fs-_6rem">
                <div class="d-flex">
                    <i class="bi bi-star me-1 text-warning"></i>
                    <span>玩家完成每日任务激活领取按钮，且每日00:00~06:00不可领取。</span>
                </div>
                <div class="d-flex align-items-center">
                    <i class="bi bi-star me-1 d-flex text-warning"></i>
                    <span>领取后将获得本次活动对应面额的代券。</span>
                </div>
                <div class="d-flex">
                    <i class="bi bi-star me-1 text-warning"></i>
                    <span>代券代替对应币种在使用时优先扣除，且使用后只返还剩余面额及被使用部分所得盈利。</span>
                </div>
                <div class="d-flex align-items-center">
                    <i class="bi bi-star me-1 d-flex text-warning"></i>
                    <span>任务每日06:00点刷新重置。</span>
                </div>
                <div class="d-flex align-items-center">
                    <i class="bi bi-star me-1 d-flex text-warning"></i>
                    <span>代券自领取之日起有效期3天。</span>
                </div>
                <div class="d-flex align-items-center">
                    <i class="bi bi-star me-1 d-flex text-warning"></i>
                    <span>本活动最终解释权归本平台所有。</span>
                </div>
            </div>
        </div>
        <!-- 领取 -->
        <div class="p-2 position-relative">
            <div @click="getCash" :class="[(isCash||taskProgress[0]<=taskProgress[1])?'bg-silver':'btn-khaki']" class="rounded fw-bold text-center text-dark py-1 ">{{getCashText}}</div>
        </div>
        <!-- 关闭 -->
        <div class="position-absolute top-0 end-0 triangle-top-end" @click="$emit('close')">
            <i class="bi bi-x-lg position-absolute top-0 mt-1_25rem text-dark"></i>
        </div>
    </div>
</template>
<script>
import {COMMAND,RULE_TYPE,TASK_PRIZE_TYPE} from "@/assets/js/config.js"
export default{
    directives:{
        'load':{
            created(elem,binding) {
                let _this=binding.instance;
                //获取玩法配置信息
                // _this.$root.wsSend(COMMAND.all_getrule,RULE_TYPE.task, _this.userInfo.id,_this.userInfo.guid);
                _this.$root.wsSendJson({
                    command:COMMAND.all_getrule,
                    ruleType:RULE_TYPE.task,
                    userid:_this.userInfo.id,
                    guid:_this.userInfo.guid
                });
            },
        }
    },
    props:{
        //是否显示活动主面板
        isShowPanel:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            TASK_PRIZE_TYPE,
            taskText:"",//任务描述
            taskProgress:[0,0],//任务进度
            prize:"",//奖励
            prizeType:0,//奖励类型
            isCash:false,//是否已兑奖
        }
    },
    computed:{
        userInfo() {
            return this.$store.state.userInfo;
        },
        getCashText(){
            let now=new Date();
            let hour=now.getHours();
            let minutes=now.getMinutes();
            if(this.isCash){
                return "已领取";
            }
            if((hour>=0&&hour<6)||(hour==6&&minutes==0)){
                return "禁领时段";
            }
            if(this.taskProgress[0]<this.taskProgress[1]){
                return "完成任务后激活";
            }
            if(this.taskProgress[0]>=this.taskProgress[1]){
                return "立即领取";
            }
        }
    },
    unmounted(){
        delete this.$root.wsMsgObj["taskTicket"];
    },
    mounted() {
        this.$root.wsMsgObj["taskTicket"]=(data)=>{
            switch (data.command) {
                case COMMAND.all_getrule:
                    if(data.type==RULE_TYPE.task){
                        this.taskText=data.task.task;
                        this.taskProgress=data.task.progress;
                        this.prize=data.task.prize.val;
                        this.prizeType=data.task.prize.type;
                        this.isCash=data.task.iscash?true:false;
                    }
                    break;
                case COMMAND.all_setruletype:
                    if(data.type==4&&data.result==1){
                        this.isCash=true;
                        //获取用户券
                        // this.$root.wsSend(COMMAND.all_getticket,this.userInfo.id, this.userInfo.guid);
                        this.$root.wsSendJson({
                            command: COMMAND.all_getticket,
                            userid: this.userInfo.id,
                            guid: this.userInfo.guid
                        });
                    }
                    break;
                case COMMAND.all_getgain:
                    // this.isShowPanel&&this.$root.wsSend(COMMAND.all_getrule,RULE_TYPE.task, this.userInfo.id,this.userInfo.guid);//显示面板的状态下需要实时更新
                    this.isShowPanel&&this.$root.wsSendJson({
                        command:COMMAND.all_getrule,
                        ruleType:RULE_TYPE.task,
                        userid:this.userInfo.id,
                        guid:this.userInfo.guid
                    });
                    break;
            }
        }
    },
    methods: {
        /**
         * 兑奖
         */
        getCash(){
            if(this.isCash||this.taskProgress[0]<=this.taskProgress[1]){//已兑奖||未达标
                return;
            }
            // this.$root.wsSend(COMMAND.all_setruletype,RULE_TYPE.task,4,this.userInfo.id,this.userInfo.guid);
            this.$root.wsSendJson({
                command:COMMAND.all_setruletype,
                ruleType:RULE_TYPE.task,
                ruleMode:4,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
        }
    },
}
</script>